import approvalInquiry from '@/lang/views/liff/ApprovalInquiry-en'
import attendanceForm from '@/lang/components/inquiryAndAttendance/AttendanceForm-en'
import averageTimeCheckInGraph from '@/lang/components/dashboard/AverageTimeCheckInGraph-en'
import billboard from '@/lang/components/message/Billboard-en'
import billboardAndIndividual from '@/lang/views/message/BillboardAndIndividual-en'
import blacklist from './components/companySetting/Blacklist-en'
import blacklistForm from '@/lang/views/blacklist/BlacklistForm-en'
import savePlace from './components/companySetting/SavePlace-en'
import savePlaceForm from '@/lang/views/savePlace/SavePlaceForm-en'
import branch from '@/lang/components/companySetting/Branch-en'
import branchFormModal from '@/lang/components/modal/BranchFormModal-en'
import changePasswordModal from '@/lang/components/modal/ChangePasswordModal-en'
import checkInLocation from '@/lang/components/inquiryAndAttendance/CheckInLocation-en'
import checkinOnsite from '@/lang/views/liff/CheckinOnSite-en'
import companyHoliday from '@/lang/components/companySetting/CompanyHoliday-en'
import companyHolidayForm from '@/lang/components/modal/CompanyHolidayForm-en'
import companyProfile from '@/lang/components/companySetting/CompanyProfile-en'
import companySetting from '@/lang/views/CompanySetting-en'
import daily from '@/lang/components/report/Daily-en'
import dashboard from '@/lang/views/dashboard/Dashboard-en'
import deleteModal from '@/lang/components/modal/DeleteModal-en'
import departmemtFormModal from '@/lang/components/modal/DepartmemtFormModal-en'
import department from '@/lang/components/companySetting/Department-en'
import employee from '@/lang/views/employee/Employees-en'
import employeeForm from '@/lang/views/employee/EmployeeForm-en'
import employeeImport from '@/lang/views/employee/EmployeeImport-en'
import employeeImportImage from '@/lang/components/employee/EmployeeImportImage-en'
import employeeImportList from '@/lang/components/employee/EmployeeImportList-en'
import employeeSummaryBox from '@/lang/components/dashboard/EmployeeSummaryBox-en'
import { en } from 'vuetify/lib/locale'
import errorModal from '@/lang/components/modal/ErrorModal-en'
import exportEmployeeModal from '@/lang/components/modal/ExportEmployeeModal-en'
import groupAttendaceDetail from '@/lang/views/liff/GroupAttendaceDetail-en'
import groupHoliday from '@/lang/components/timeTableSetting/GroupHoliday-en'
import groupHolidayFormModal from '@/lang/components/modal/GroupHolidayFormModal-en'
import groupNormalWorkday from '@/lang/components/timeTableSetting/GroupNormalWorkday-en'
import groupWorkdayForm from '@/lang/views/timeTableSetting/GroupWorkdayForm-en'
import importEmployeeErrorModal from '@/lang/components/modal/ImportEmployeeErrorModal-en'
import importEmployeesFormModal from '@/lang/components/modal/ImportEmployeesFormModal-en'
import individual from '@/lang/components/message/Individual-en'
import infoModal from '@/lang/components/modal/InfoModal-en'
import inquiry from '@/lang/components/inquiryAndAttendance/Inquiry-en'
import inquiryForm from '@/lang/components/inquiryAndAttendance/InquiryForm-en'
import inquiryQuickReview from '@/lang/components/dashboard/InquiryQuickReview-en'
import leaveQuota from '@/lang/components/companySetting/LeaveQuota-en'
import liff from '@/lang/views/liff/Liff-en'
import liffOvertimeRequest from '@/lang/views/liff/OvertimeRequest-en'
import lineRegisCodeModal from '@/lang/components/modal/LineRegisCodeModal-en'
import lineService from '@/lang/components/companySetting/LineService-en'
import logoutModal from '@/lang/components/modal/LogoutModal-en'
import manageAttendance from '@/lang/components/inquiryAndAttendance/ManageAttendance-en'
import messageModal from '@/lang/components/modal/MessageModal-en'
import monthly from '@/lang/components/report/Monthly-en'
import onsiteTodayTable from '@/lang/components/dashboard/OnsiteTodayTable-en'
import overtimeRequest from '@/lang/components/inquiryAndAttendance/OvertimeRequest-en'
import overtimeRequestForm from '@/lang/views/inquiryAndAttendance/OvertimeRequestForm-en'
import pin from '@/lang/views/Pin-en'
import profile from '@/lang/components/Profile-en'
import punchLog from '@/lang/components/inquiryAndAttendance/PunchLog-en'
import report from '@/lang/views/Report-en'
import resetPinForm from '@/lang/components/modal/ResetPinForm-en'
import sidebar from '@/lang/components/Sidebar-en'
import specialWorkday from '@/lang/components/timeTableSetting/SpecialWorkday-en'
import specialWorkdayFormModal from '@/lang/components/modal/SpecialWorkdayFormModal-en'
import statusAttendance from '@/lang/components/inquiryAndAttendance/StatusAttendance-en'
import successModal from '@/lang/components/modal/SuccessModal-en'
import timeTableSetting from '@/lang/views/timeTableSetting/TimeTableSetting-en'
import toggleStatus from '@/lang/components/ToggleStatus-en'
import totalEmployeeGraph from '@/lang/components/dashboard/TotalEmployeeGraph-en'
import userFormModal from '@/lang/components/modal/UserFormModal-en'
import userManagement from '@/lang/components/companySetting/UserManagement-en'
import userProfile from '@/lang/views/UserProfile-en'
import visitor from '@/lang/views/visitor/Visitor-en'
import visitorActivity from '@/lang/components/visitor/VisitorActivity-en'
import visitorAttendance from '@/lang/components/visitor/VisitorAttendance-en'
import visitorForm from '@/lang/views/visitor/VisitorForm-en'
import weeklyCalendar from '@/lang/components/WeeklyCalendar-en'
import checkInLocationDetail from '@/lang/components/inquiryAndAttendance/CheckInLocationDetail-en'

export default {
    ...en,
    checkInLocation,
    dashboard,
    averageTimeCheckInGraph,
    employeeSummaryBox,
    inquiryQuickReview,
    onsiteTodayTable,
    totalEmployeeGraph,
    weeklyCalendar,
    sidebar,
    companySetting,
    companyProfile,
    branch,
    blacklist,
    blacklistForm,
    savePlace,
    savePlaceForm,
    branchFormModal,
    userManagement,
    department,
    lineService,
    billboardAndIndividual,
    billboard,
    individual,
    messageModal,
    companyHoliday,
    leaveQuota,
    inquiry,
    manageAttendance,
    inquiryForm,
    attendanceForm,
    employee,
    employeeImport,
    employeeImportImage,
    employeeImportList,
    employeeForm,
    importEmployeesFormModal,
    importEmployeeErrorModal,
    lineRegisCodeModal,
    timeTableSetting,
    groupNormalWorkday,
    specialWorkday,
    specialWorkdayFormModal,
    groupHoliday,
    groupHolidayFormModal,
    groupWorkdayForm,
    toggleStatus,
    report,
    daily,
    monthly,
    visitor,
    visitorForm,
    visitorActivity,
    visitorAttendance,
    deleteModal,
    statusAttendance,
    profile,
    userProfile,
    userFormModal,
    departmemtFormModal,
    companyHolidayForm,
    changePasswordModal,
    pin,
    resetPinForm,
    successModal,
    errorModal,
    exportEmployeeModal,
    groupAttendaceDetail,
    logoutModal,
    approvalInquiry,
    liff,
    infoModal,
    checkinOnsite,
    overtimeRequest,
    punchLog,
    liffOvertimeRequest,
    overtimeRequestForm,
    checkInLocationDetail
}
